export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#001E3C] text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-[#00D9C9] to-[#00F5E0] bg-clip-text text-transparent">
              HI-TAK
            </h3>
            <p className="text-white/70 mb-6 text-sm leading-relaxed">
              Leading provider of precision deep hole drilling, honing, and gun drilling solutions for industries worldwide.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#00D9C9] transition-all duration-300 flex items-center justify-center group cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#00D9C9] transition-all duration-300 flex items-center justify-center group cursor-pointer"
              >
                <i className="ri-twitter-fill text-xl group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#00D9C9] transition-all duration-300 flex items-center justify-center group cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#00D9C9] transition-all duration-300 flex items-center justify-center group cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl group-hover:scale-110 transition-transform"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  Deep Hole Drilling
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  Honing
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  Gun Drilling
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  Custom Solutions
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-bold mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('strengths')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('applications')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  Industries
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('news')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  News & Updates
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-bold mb-6">Stay Updated</h4>
            <p className="text-white/70 mb-4 text-sm">
              Subscribe to our newsletter for the latest updates and insights.
            </p>
            <form className="space-y-3">
              <input
                type="email"
                placeholder="Your email"
                className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-[#00D9C9] transition-colors duration-200 text-sm"
              />
              <button
                type="submit"
                className="w-full bg-[#00D9C9] text-[#001E3C] px-6 py-3 rounded-lg font-bold hover:bg-[#00F5E0] transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © 2024 HI-TAK Corporation. All rights reserved.
            </p>
            <div className="flex gap-6">
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-white/50 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-white/50 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
              >
                Terms of Service
              </button>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/50 hover:text-[#00D9C9] transition-colors duration-200 text-sm cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
